export const productDetailsData = {
  1: {
    id: 1,
    seo: {
      tr: {
        title: "Glukonik Asit %50 - Türkiye Üreticisi | Meskim Gıda",
        description: "Glukonik asit %50 sıvı form. Gıda katkı maddesi, pH düzenleyici, beton katkısı. Türkiye'nin ilk üreticisi. 7000+ ton/yıl kapasite.",
        keywords: "glukonik asit, gluconic acid, glukonik asit fiyat, glukonik asit üreticisi, glukonik asit satış, gıda katkı maddesi, pH düzenleyici, beton geciktirici, metal temizleyici, glukonik asit nedir, glukonik asit kullanım alanları"
      },
      en: {
        title: "Gluconic Acid 50% - Turkey Manufacturer | Meskim Food",
        description: "Gluconic acid 50% liquid form. Food additive, pH regulator, concrete admixture. Turkey's first producer. 7000+ tons/year capacity.",
        keywords: "gluconic acid, gluconic acid manufacturer, gluconic acid turkey, food additive, pH regulator, concrete retarder, metal cleaner, gluconic acid supplier, gluconic acid 50%, gluconic acid price"
      }
    },
    technicalDetails: {
      tr: {
        formula: "C₆H₁₂O₇",
        casNumber: "526-95-4",
        appearance: "Açık sarı şeffaf sıvı",
        concentration: "%50 ± 0.5",
        density: "1.23 - 1.25 g/cm³ (20°C)",
        ph: "1.8 - 3.5 (%50 çözelti)",
        solubility: "Suda tamamen çözünür"
      },
      en: {
        formula: "C₆H₁₂O₇",
        casNumber: "526-95-4",
        appearance: "Light yellow transparent liquid",
        concentration: "50% ± 0.5",
        density: "1.23 - 1.25 g/cm³ (20°C)",
        ph: "1.8 - 3.5 (50% solution)",
        solubility: "Completely soluble in water"
      },
      ru: {
        formula: "C₆H₁₂O₇",
        casNumber: "526-95-4",
        appearance: "Светло-желтая прозрачная жидкость",
        concentration: "50% ± 0.5",
        density: "1.23 - 1.25 г/см³ (20°C)",
        ph: "1.8 - 3.5 (50% раствор)",
        solubility: "Полностью растворим в воде"
      },
      ar: {
        formula: "C₆H₁₂O₇",
        casNumber: "526-95-4",
        appearance: "سائل شفاف أصفر فاتح",
        concentration: "50% ± 0.5",
        density: "1.23 - 1.25 جم/سم³ (20°C)",
        ph: "1.8 - 3.5 (محلول 50%)",
        solubility: "قابل للذوبان تماماً في الماء"
      }
    },
    packaging: ["ibcTank", "barrel"],
    isFirstProducer: true,
    image: "/images/gluconic-acid.jpg"
  },
  2: {
    id: 2,
    seo: {
      tr: {
        title: "Sodyum Glukonat, Potasyum Glukonat, Kalsiyum Glukonat | Meskim",
        description: "Glukonat tuzları %32 ve %40 sıvı ürün. Sodyum glukonat, potasyum glukonat, kalsiyum glukonat, bakır glukonat üretimi ve satışı.",
        keywords: "sodyum glukonat, sodium gluconate, potasyum glukonat, kalsiyum glukonat, bakır glukonat, glukonat tuzları, beton katkı maddesi, gıda takviyesi, ilaç üretimi, su arıtma, glukonat satış"
      },
      en: {
        title: "Sodium Gluconate, Potassium Gluconate, Calcium Gluconate | Meskim",
        description: "Gluconate salts 32% and 40% liquid product. Sodium gluconate, potassium gluconate, calcium gluconate, copper gluconate production.",
        keywords: "sodium gluconate, potassium gluconate, calcium gluconate, copper gluconate, gluconate salts, concrete additive, dietary supplement, pharmaceutical, water treatment, gluconate manufacturer turkey"
      }
    },
    technicalDetails: {
      tr: {
        types: "Sodyum, Potasyum, Kalsiyum, Bakır Glukonat",
        appearance: "%32'lik ve %40'lık sıvı ürün",
        purity: "Min. %98",
        solubility: "Suda çözünür",
        storage: "Serin ve kuru yerde muhafaza"
      },
      en: {
        types: "Sodium, Potassium, Calcium, Copper Gluconate",
        appearance: "32% and 40% liquid product",
        purity: "Min. 98%",
        solubility: "Soluble in water",
        storage: "Store in cool and dry place"
      },
      ru: {
        types: "Глюконат натрия, калия, кальция, меди",
        appearance: "Жидкий продукт 32% и 40%",
        purity: "Мин. 98%",
        solubility: "Растворим в воде",
        storage: "Хранить в прохладном и сухом месте"
      },
      ar: {
        types: "جلوكونات الصوديوم والبوتاسيوم والكالسيوم والنحاس",
        appearance: "منتج سائل 32% و 40%",
        purity: "دقيقة. 98%",
        solubility: "قابل للذوبان في الماء",
        storage: "يحفظ في مكان بارد وجاف"
      }
    },
    packaging: ["ibcTank", "barrel"],
    isFirstProducer: false,
    image: "/images/sodium-gluconate.jpg"
  },
  3: {
    id: 3,
    seo: {
      tr: {
        title: "Glukono Delta Lakton (GDL) - Türkiye Üreticisi | Meskim Gıda",
        description: "Glukono delta lakton GDL üretimi. Peynir üretimi, et ürünleri, fırıncılık, tofu üretimi için asitlik düzenleyici. Türkiye'nin tek üreticisi.",
        keywords: "glukono delta lakton, GDL, glucono delta lactone, peynir üretimi, asitlik düzenleyici, gıda katkı maddesi, tofu yapımı, fırıncılık, et ürünleri, GDL fiyat, GDL satış, GDL nedir"
      },
      en: {
        title: "Glucono Delta Lactone (GDL) - Turkey Manufacturer | Meskim Food",
        description: "Glucono delta lactone GDL production. Cheese production, meat products, bakery, tofu making acidity regulator. Turkey's only producer.",
        keywords: "glucono delta lactone, GDL, cheese production, acidity regulator, food additive, tofu making, bakery products, meat processing, GDL manufacturer, GDL supplier turkey, GDL price"
      }
    },
    technicalDetails: {
      tr: {
        formula: "C₆H₁₀O₆",
        casNumber: "90-80-2",
        appearance: "Beyaz kristal toz",
        purity: "Min. %99",
        melting: "150-152°C",
        solubility: "Suda çözünür",
        storage: "Kapalı ambalajında, serin ve kuru yerde"
      },
      en: {
        formula: "C₆H₁₀O₆",
        casNumber: "90-80-2",
        appearance: "White crystalline powder",
        purity: "Min. 99%",
        melting: "150-152°C",
        solubility: "Soluble in water",
        storage: "In sealed packaging, cool and dry place"
      },
      ru: {
        formula: "C₆H₁₀O₆",
        casNumber: "90-80-2",
        appearance: "Белый кристаллический порошок",
        purity: "Мин. 99%",
        melting: "150-152°C",
        solubility: "Растворим в воде",
        storage: "В герметичной упаковке, в прохладном и сухом месте"
      },
      ar: {
        formula: "C₆H₁₀O₆",
        casNumber: "90-80-2",
        appearance: "مسحوق بلوري أبيض",
        purity: "دقيقة. 99%",
        melting: "150-152°C",
        solubility: "قابل للذوبان في الماء",
        storage: "في عبوة محكمة الإغلاق، مكان بارد وجاف"
      }
    },
    packaging: ["kraftBag"],
    isFirstProducer: true,
    image: "/images/gdl-product.jpg"
  }
};
